/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChefsEntrepriseDoublonGridDto } from './ChefsEntrepriseDoublonGridDto';
import {
    ChefsEntrepriseDoublonGridDtoFromJSON,
    ChefsEntrepriseDoublonGridDtoFromJSONTyped,
    ChefsEntrepriseDoublonGridDtoToJSON,
} from './ChefsEntrepriseDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ChefsEntrepriseDoublonGridDtoPaginatedResults
 */
export interface ChefsEntrepriseDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ChefsEntrepriseDoublonGridDto>}
     * @memberof ChefsEntrepriseDoublonGridDtoPaginatedResults
     */
    results?: Array<ChefsEntrepriseDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ChefsEntrepriseDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ChefsEntrepriseDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfChefsEntrepriseDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefsEntrepriseDoublonGridDtoPaginatedResultsFromJSON(json: any): ChefsEntrepriseDoublonGridDtoPaginatedResults {
    return ChefsEntrepriseDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ChefsEntrepriseDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefsEntrepriseDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ChefsEntrepriseDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ChefsEntrepriseDoublonGridDtoPaginatedResultsToJSON(value?: ChefsEntrepriseDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ChefsEntrepriseDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

